import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  add: {
    id: 'shared.modal_choose_image.add',
    defaultMessage: 'Add new',
  },
  flag: {
    id: 'shared.modal_choose_image.flag',
    defaultMessage: 'Set this image as the default for the donation alert',
  },
  removeFlag: {
    id: 'shared.modal_choose_image.remove_flag',
    defaultMessage: 'Remove the default image for the donation alert',
  },
})
